<script>

import Icons from '../icon'
import { Line } from 'vue-chartjs'

export default {   
    name: 'star-partial',
    extends: Line,

    props: {
		response: {
			type: Object,
        },
        // Content object for this question
		question: {
			type: Object,
			required: true
        },
        isSurvey: {
            type: Boolean,
            default: false
        },
        data: {
            type: Array
        }
    },


	mounted() {
		this.renderChart({
            labels:  this.getLabels, // X axis
            datasets: [
                {
                    label: 'Response',
                    backgroundColor: 'skyblue',
                    borderColor: 'skyblue',
                    data: this.getData,
                    fill: false,
                    
                }
            ]
        }, { responsive: true, maintainAspectRatio: false, 
                scales: {
                    yAxes: [{
                        display: true,
                        ticks: {
                            stepSize: 1,
                            max: 5,
                            min: 1
                        }
                    }]
                }
            }
        )
	},
    
    methods: {
    },
    computed: {
        getLabels() {
            return this.data.map(d => d.date).reverse()
        },
        getData() {
            return this.data.map(d => parseInt(d.value)+1).reverse()
        }
    },
    
    components: {
		...Icons,
	}
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
</style>
